import React, { useState, useContext, useEffect } from "react";
import { UserInformationContext, SitterUserInformationContext, C4FStatusContext, ReferenceDataContext } from "../main/App";
import { Dropdown, DropdownButton, Button, ButtonGroup, Form, Alert, Modal, InputGroup, Table } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { getRegularTeam, validateUserName } from "../common/Helpers";
import '../css/general.css';
import axios from 'axios';
import config from "../etc/config.json";
import md5 from 'md5-hash';
import SkillClimbing from "../img/icons/skill-climbing.png";
import SkillFlat from "../img/icons/skill-flat.png";
import SkillDownhill from "../img/icons/skill-downhill.png";
import SkillTimeTrial from "../img/icons/skill-timetrial.png";
import SkillSprint from "../img/icons/skill-sprint.png";
import SkillCobbles from "../img/icons/skill-cobbles.png";
import SkillRegeneration from "../img/icons/skill-regeneration.png";
import moment from 'moment';
import { Stage, Layer, Image } from 'react-konva';
import useImage from 'use-image';

import SampleJersey from "../img/teamjerseys/trikot_base.png";
import TrikotBaseSimpleBg from "../img/teamjerseys/trikot_base_bg_screen_empty.png";
import TrikotBaseSimple from "../img/teamjerseys/trikot_base_simple.png";

import JerseyApricot from "../img/teamjerseys/jersey_apricot.png";
import JerseyBurgundy from "../img/teamjerseys/jersey_burgundy.png";
import JerseyCharcoal from "../img/teamjerseys/jersey_charcoal.png";
import JerseyChocolate from "../img/teamjerseys/jersey_chocolate.png";
import JerseyEbony from "../img/teamjerseys/jersey_ebony.png";
import JerseyIvory from "../img/teamjerseys/jersey_ivory.png";
import JerseyLavender from "../img/teamjerseys/jersey_lavender.png";
import JerseyMint from "../img/teamjerseys/jersey_mint.png";
import JerseyNavy from "../img/teamjerseys/jersey_navy.png";
import JerseySky from "../img/teamjerseys/jersey_sky.png";

import BibApricot from "../img/teamjerseys/bib_apricot.png";
import BibBurgundy from "../img/teamjerseys/bib_burgundy.png";
import BibCharcoal from "../img/teamjerseys/bib_charcoal.png";
import BibChocolate from "../img/teamjerseys/bib_chocolate.png";
import BibEbony from "../img/teamjerseys/bib_ebony.png";
import BibIvory from "../img/teamjerseys/bib_ivory.png";
import BibLavender from "../img/teamjerseys/bib_lavender.png";
import BibMint from "../img/teamjerseys/bib_mint.png";
import BibNavy from "../img/teamjerseys/bib_navy.png";
import BibSky from "../img/teamjerseys/bib_sky.png";

import BikeApricot from "../img/teamjerseys/bike_apricot.png";
import BikeBurgundy from "../img/teamjerseys/bike_burgundy.png";
import BikeCharcoal from "../img/teamjerseys/bike_charcoal.png";
import BikeChocolate from "../img/teamjerseys/bike_chocolate.png";
import BikeEbony from "../img/teamjerseys/bike_ebony.png";
import BikeIvory from "../img/teamjerseys/bike_ivory.png";
import BikeLavender from "../img/teamjerseys/bike_lavender.png";
import BikeMint from "../img/teamjerseys/bike_mint.png";
import BikeNavy from "../img/teamjerseys/bike_navy.png";
import BikeSky from "../img/teamjerseys/bike_sky.png";

function Profile(props) {

  const { userInformation, setUserInformation } = useContext(UserInformationContext);
  const { showBanner, setShowBanner, handleBackendRequest, raiseError } = useContext(C4FStatusContext);
  const { setSitterUserInformation } = useContext(SitterUserInformationContext);
  const { countries } = useContext(ReferenceDataContext);
  const [team, setTeam] = useState(null);
  const [tab, setTab] = useState('profile');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newUserName, setNewUserName] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [newAcronym, setNewAcronym] = useState('');
  const [newForumAccount, setNewForumAccount] = useState('');
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState('');
  const [changeProfileInfo, setChangeProfileInfo] = useState('');
  const [nameChangeInfo, setNameChangeInfo] = useState('');
  const [jerseyChangeInfo, setJerseyChangeInfo] = useState('');
  const [motto, setMotto] = useState(null);
  const [resetInfo, setResetInfo] = useState('');
  const [generatedTeamType, setGeneratedTeamType] = useState('Sprint');
  const [showResetModal, setShowResetModal] = useState(false);
  const handleReset = () => resetTeam();
  const [showUsernameForm, setShowUsernameForm] = useState(false);
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [showAcronymForm, setShowAcronymForm] = useState(false);
  const [showForumAccountForm, setShowForumAccountForm] = useState(false);
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [showMottoForm, setShowMottoForm] = useState(false);
  const [showNameChangeModal, setShowNameChangeModal] = useState(false);
  const [showJerseyEdit, setShowJerseyEdit] = useState(false);
  const [jerseyColor, setJerseyColor] = useState('select');
  const [jersey, setJersey] = useState(null);
  const [bibColor, setBibColor] = useState('select');
  const [bib, setBib] = useState(null);
  const [bikeColor, setBikeColor] = useState('select');
  const [bike, setBike] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileURL, setSelectedFileURL] = useState(null);
  const [imageAlert, setImageAlert] = useState('');
  const [additionalSitter, setAdditionalSitter] = useState('');
  const navigate = useNavigate();
  const date = new Date();

  const handleFileSelect = (e) => {
    setJerseyChangeInfo('');
    if (e.target.files.length) {
      let fileSize = e.target.files[0].size;
      let fileType = e.target.files[0].type;
      if (fileType !== "image/png") {
        setImageAlert('File is not .png-file !');
        setSelectedFile(null);
        setSelectedFileURL(null);
      }
      else if (fileSize >= 1000000) {
        setImageAlert('File Size > 1MB !');
        setSelectedFile(null);
        setSelectedFileURL(null);
      }
      else {
        setImageAlert('File OK.');
        setSelectedFile(e.target.files[0]);
        setSelectedFileURL(URL.createObjectURL(e.target.files[0]));
        setJerseyColor('select');
        setJersey(null);
        setBibColor('select');
        setBib(null);
        setBikeColor('select');
        setBike(null);
      }
    }
    else {
      setImageAlert('No file chosen !');
      setSelectedFile(null);
      setSelectedFileURL(null);
    }
  }

  function handleAnonymousChat(anonymousChat) { patchUser('anonymousChat', anonymousChat) }
  function handleFirstSteps(firstSteps) { patchUser('firstSteps', firstSteps) }
  function handleLanguage(language) { patchUser('language', language) }
  function handleMotto() { patchUser('motto', motto) }
  function handleEmail() { patchUser('emailAddress', newEmail) }
  function handleAcronym() { 
    if (!newAcronym.match(/^[A-Z0-9]{3}$/) || !newAcronym.match(/[A-Z]/)) {
      raiseError('Change of Acronym', 0, 'Acronym needs to consist only of letters and numbers, no special characters (umlaut or accents), only upper case, exactly three characters, at least one letter.');
      return;
    }
    patchUser('acronym', newAcronym) 
  }
  function handleForumAccount() { patchUser('forumAccount', newForumAccount) }

  function patchUser(key, value) {
    handleBackendRequest('PATCH', '/user/' + userInformation.userName, {},
      {
        key: key,
        value: value
      },
      function (user) {
        setChangeProfileInfo(key + ' changed.');
        setUserInformation(user);
        setMotto(user.motto);
        setShowMottoForm(false);
        setShowEmailForm(false);        
      });
  }

  function handleChangePassword() {
    if (newPassword !== newPasswordConfirmation)
      raiseError('Change Failed', 0, 'confirmed password is different from new password');
    else if (newPassword === oldPassword)
      raiseError('Change Failed', 0, 'new password is same as old password');
    else {
      handleBackendRequest('POST', '/user/' + userInformation.userName + '/changePassword', {},
        {
          oldEncryptedPassword: md5(oldPassword),
          newEncryptedPassword: md5(newPassword)
        },
        function () {
          setChangeProfileInfo('Password changed.');
          setOldPassword('');
          setNewPassword('');
          setNewPasswordConfirmation('');
          setShowPasswordForm(false);
        }, false);
    }
  }

  function handleNameChange() {
    setShowNameChangeModal(false)
    handleBackendRequest('POST', '/user/' + userInformation.userName + '/changeUserName', {},
      {
        newUserName: newUserName
      },
      function (user) {
        setUserInformation(user);
        loadTeam(getRegularTeam(user).teamName);
        setNameChangeInfo('Username changed. Please logout and login to complete the change.');
        setNewUserName('');
      });
  }


  function resetTeam() {
    setShowResetModal(false);

    handleBackendRequest('POST', '/team/' + userInformation.userName + '/reset', {}, null,
      function (team) {
        setTeam(team);
        setResetInfo('Success. Your Team was reset.');
      });
  }

  function handleGenerateRiders() {
    handleBackendRequest('POST', '/team/' + userInformation.userName + '/generateRiders', {}, { type: generatedTeamType },
      function () {
        setResetInfo('Success. Your team has been created. You can view the team in the Team-Page.');
      }, false);
  }

  function handleJerseyChange() {
    setShowNameChangeModal(false)
    handleBackendRequest('POST', '/user/' + userInformation.userName + '/changeJersey', {},
      {
        jerseyColor: jerseyColor,
        bibColor: bibColor,
        bikeColor: bikeColor
      },
      function () {
        loadTeam(getRegularTeam(userInformation).teamName);
        setJerseyChangeInfo('Jersey saved.');
      }, false);
  }

  function handleCustomJersey() {
    let data = new FormData();
    data.append('file', selectedFile);
    data.append('teamId', team.id);

    axios.post(config.UTILS + "/UploadCustomJersey.php", data, { withCredentials: true })
      .then(result => {
        if (result.status === 200) {
          if (typeof result.data.errorMessage !== 'undefined')
            raiseError('Change Failed', 0, result.data.errorMessage);
          else {
            loadTeam(getRegularTeam(userInformation).teamName);
            setJerseyChangeInfo('Jersey saved.');
          }
        }
      }).catch(({ response }) => {
        raiseError('Change Failed', 0, response.data.errorMessage);
      });
  }

  function loadTeam(teamName) {
    handleBackendRequest('GET', '/team/' + teamName, null, null,
      function (team) {
        setTeam(team);
      });
  }

  const RiderImage = props => {
    const [image] = useImage(props.url);
    return <>
      <Image
        image={image} x={props.x} y={props.y}
        width={props.width} height={props.height}
      />
    </>;
  };

  function handleJerseyColor(newColor) {
    setJerseyColor(newColor);
    if (newColor === 'select') {
      setJersey(null);
    }
    else if (newColor === 'apricot') {
      setJersey(JerseyApricot);
    }
    else if (newColor === 'burgundy') {
      setJersey(JerseyBurgundy);
    }
    else if (newColor === 'charcoal') {
      setJersey(JerseyCharcoal);
    }
    else if (newColor === 'chocolate') {
      setJersey(JerseyChocolate);
    }
    else if (newColor === 'ebony') {
      setJersey(JerseyEbony);
    }
    else if (newColor === 'ivory') {
      setJersey(JerseyIvory);
    }
    else if (newColor === 'lavender') {
      setJersey(JerseyLavender);
    }
    else if (newColor === 'mint') {
      setJersey(JerseyMint);
    }
    else if (newColor === 'navy') {
      setJersey(JerseyNavy);
    }
    else if (newColor === 'sky') {
      setJersey(JerseySky);
    }
  }

  function handleBibColor(newColor) {
    setBibColor(newColor);
    if (newColor === 'select') {
      setBib(null);
    }
    else if (newColor === 'apricot') {
      setBib(BibApricot);
    }
    else if (newColor === 'burgundy') {
      setBib(BibBurgundy);
    }
    else if (newColor === 'charcoal') {
      setBib(BibCharcoal);
    }
    else if (newColor === 'chocolate') {
      setBib(BibChocolate);
    }
    else if (newColor === 'ebony') {
      setBib(BibEbony);
    }
    else if (newColor === 'ivory') {
      setBib(BibIvory);
    }
    else if (newColor === 'lavender') {
      setBib(BibLavender);
    }
    else if (newColor === 'mint') {
      setBib(BibMint);
    }
    else if (newColor === 'navy') {
      setBib(BibNavy);
    }
    else if (newColor === 'sky') {
      setBib(BibSky);
    }
  }

  function handleBikeColor(newColor) {
    setBikeColor(newColor);
    if (newColor === 'select') {
      setBike(null);
    }
    else if (newColor === 'apricot') {
      setBike(BikeApricot);
    }
    else if (newColor === 'burgundy') {
      setBike(BikeBurgundy);
    }
    else if (newColor === 'charcoal') {
      setBike(BikeCharcoal);
    }
    else if (newColor === 'chocolate') {
      setBike(BikeChocolate);
    }
    else if (newColor === 'ebony') {
      setBike(BikeEbony);
    }
    else if (newColor === 'ivory') {
      setBike(BikeIvory);
    }
    else if (newColor === 'lavender') {
      setBike(BikeLavender);
    }
    else if (newColor === 'mint') {
      setBike(BikeMint);
    }
    else if (newColor === 'navy') {
      setBike(BikeNavy);
    }
    else if (newColor === 'sky') {
      setBike(BikeSky);
    }
  }

  function removeSitter(userName) {
    handleBackendRequest('POST', '/user/' + userInformation.userName + '/removeSitter', {}, { sitterName: userName }, setUserInformation);
  }

  function addSitter(userName) {
    handleBackendRequest('POST', '/user/' + userInformation.userName + '/addSitter', {}, { sitterName: userName }, setUserInformation);
  }

  function enterSittingAccount(userName) {
    handleBackendRequest('GET', '/user/' + userName, null, null,
      function (sittedUser) {
        setUserInformation(sittedUser);
        setSitterUserInformation(userInformation);
        navigate('/home');
      });
  }

  function handleSetNewUserName(newUserName) {
    let validationResult = validateUserName(newUserName);
    setNameChangeInfo(validationResult.result ? null : validationResult.message);
    setNewUserName(newUserName);
  }

  useEffect(() => {
    if (userInformation)
      loadTeam(getRegularTeam(userInformation).teamName);
    if (userInformation && !motto)
      setMotto(userInformation.motto);
  }, []);

  if (userInformation !== null && team !== null)
    return <div className="container-fluid m-0 p-0 justify-content-center">
      <div className="row d-flex justify-content-center my-2">
        <ButtonGroup>
          <Button variant={(tab === 'profile') ? 'primary' : 'outline-primary'} onClick={() => setTab('profile')}>Profile</Button>
          <Button variant={(tab === 'sitter') ? 'primary' : 'outline-primary'} onClick={() => setTab('sitter')}>Sitter</Button>
          <Button variant={(tab === 'license') ? 'primary' : 'outline-primary'} onClick={() => setTab('license')}>License</Button>
          <Button variant={(tab === 'reset') ? 'primary' : 'outline-primary'} onClick={() => setTab('reset')}>Reset</Button>
          <Button variant={(tab === 'generate') ? 'primary' : 'outline-primary'} onClick={() => setTab('generate')}>Auto-Team</Button>
        </ButtonGroup>
      </div>
      {(() => {
        if (tab === 'profile')
          return <div className="row d-flex justify-content-center">
            <div className="col" style={{ minWidth: 400, maxWidth: "80vw" }}>
              <Modal key={'namechangeModal' + showNameChangeModal}
                show={showNameChangeModal}
                onHide={() => setShowNameChangeModal(false)} >
                <Modal.Header closeButton>
                  <Modal.Title>Name Change</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>Do you really want to change your name from {userInformation.userName} to {newUserName} for {userInformation.nameChangePrice.toLocaleString("de-DE", { style: "currency", currency: "USD", maximumFractionDigits: 0, minimumFractionDigits: 0 })}?</p>
                  <br />
                  <p><b>Info: </b>You should be sure that you chose a proper name. After the change, the price for another change depends on the days passed since your last name change. It costs max. $3,000,000 and min. $100,000 with the following formula:<br /> Price = $3,000,000 - (days / 1,095) * $2,900,000.</p>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowNameChangeModal(false)}>{'Cancel'}</Button>
                  <Button variant="success" onClick={handleNameChange}>{'OK'}</Button>
                </Modal.Footer>
              </Modal>
              <h3>General Info</h3>
              <p> On this page, you can update your user/team name, email, password, language*, chat settings**, tutorial settings** and team motto.</p>
              <p> You can also reset your team (see "Reset"-Tab), generate an automatic team (see "Auto-Team"-Tab) and view your current license status (see "License"-Tab).</p>
              <p style={{ fontSize: "0.8em" }}> *to show other players which is your primary language (game language remains English so far)<br />**possible, but changes nothing so far</p>
              <h3 className="mt-5">User Info</h3>
              <Alert key="alert1" variant={'warning'}>{changeProfileInfo}</Alert>
              <div className="" style={{ maxWidth: "80vw", maxHeight: 750, overflow: "auto", backgroundColor: 'rgba(245,250,255,1)', textAlign: "left" }}>
                <table className="table table-sm align-middle text-left">
                  <thead>
                    <tr>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><b>User/Team</b></td>
                      {(() => {
                        if (showUsernameForm) {
                          return <td>
                            <Form.Control type="text"
                              onChange={(e) => handleSetNewUserName(e.target.value)}
                              placeholder={userInformation.userName}
                              value={newUserName} />
                            <ButtonGroup>
                              <Button variant="success py-0" disabled={nameChangeInfo} onClick={() => setShowNameChangeModal(true)}>✓</Button>
                              <Button variant="secondary py-0" onClick={() => setShowUsernameForm(false)}>X</Button>
                            </ButtonGroup>
                            <br />
                            <br />
                            {nameChangeInfo ?
                              <Alert key="alert2" variant={'warning'}>{nameChangeInfo}</Alert>
                              : null}
                            <b>Price for name change: </b>
                            {userInformation.nameChangePrice.toLocaleString("en-EN", { style: "currency", currency: "USD", maximumFractionDigits: 0, minimumFractionDigits: 0 })}
                            <br />
                            <b>Your balance: </b>
                            {team.balance.toLocaleString("en-EN", { style: "currency", currency: "USD", maximumFractionDigits: 0, minimumFractionDigits: 0 })}
                            <br />
                            <br />
                            <p><b>Info: </b>The first name change is free if you have less than 100 races. Afterwards, the price depends on the days passed since your last name change. It costs max. $3,000,000 and min. $100,000 with the following formula:<br /> Price = $3,000,000 - (days / 1,095) * $2,900,000.</p>
                            {(() => {
                              if (userInformation.nameChanges.length !== 0) {
                                return <table>
                                  <thead>
                                    <tr>
                                      <th>Date</th>
                                      <th>Name</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {userInformation.nameChanges.slice()
                                      .sort(function (a, b) { return b.date.localeCompare(a.date) })
                                      .map((nameChange) => (
                                        <tr>
                                          <td>{moment(nameChange.date).format('D MMM YYYY')}</td>
                                          <td>{nameChange.teamName}</td>
                                        </tr>
                                      ))
                                    }
                                  </tbody>
                                </table>
                              }
                            })()}
                          </td>
                        }
                        else {
                          return <td>
                            {userInformation.userName}&nbsp;
                            <Button variant="primary py-0" onClick={() => setShowUsernameForm(true)}>Edit</Button>
                          </td>
                        }
                      })()}
                    </tr>
                    <tr>
                      <td><b>Email</b></td>
                      {(() => {
                        if (showEmailForm) {
                          return <td>
                            <Form.Control type="text"
                              onChange={(e) => setNewEmail(e.target.value)}
                              placeholder={userInformation.emailAddress}
                              value={newEmail} />
                            <ButtonGroup>
                              <Button variant="success py-0" onClick={() => handleEmail()}>✓</Button>
                              <Button variant="secondary py-0" onClick={() => setShowEmailForm(false)}>X</Button>
                            </ButtonGroup>
                          </td>
                        }
                        else {
                          return <td>
                            {userInformation.emailAddress}&nbsp;
                            <Button variant="primary py-0" onClick={() => setShowEmailForm(true)}>Edit</Button>
                          </td>
                        }
                      })()}
                    </tr>
                  <tr>
                      <td><b>Acronym</b></td>
                      {(() => {
                        if (showAcronymForm) {
                          return <td>
                            <Form.Control type="text"
                              onChange={(e) => setNewAcronym(e.target.value)}
                              placeholder={userInformation.acronym}
                              value={newAcronym} />
                            <ButtonGroup>
                              <Button variant="success py-0" onClick={() => handleAcronym()}>✓</Button>
                              <Button variant="secondary py-0" onClick={() => setShowAcronymForm(false)}>X</Button>
                            </ButtonGroup>
                          </td>
                        }
                        else {
                          return <td>
                            {userInformation.acronym}&nbsp;
                            <Button variant="primary py-0" onClick={() => setShowAcronymForm(true)}>Edit</Button>
                          </td>
                        }
                      })()}
                    </tr>
                    <tr>
                      <td><b>ForumAccount</b></td>
                      {(() => {
                        if (showForumAccountForm) {
                          return <td>
                            <Form.Control type="text"
                              onChange={(e) => setNewForumAccount(e.target.value)}
                              placeholder={userInformation.forumAccount}
                              value={newForumAccount} />
                            <ButtonGroup>
                              <Button variant="success py-0" onClick={() => handleForumAccount()}>✓</Button>
                              <Button variant="secondary py-0" onClick={() => setShowForumAccountForm(false)}>X</Button>
                            </ButtonGroup>
                          </td>
                        }
                        else {
                          return <td>
                            {userInformation.forumAccount}&nbsp;
                            <Button variant="primary py-0" onClick={() => setShowForumAccountForm(true)}>Edit</Button>
                          </td>
                        }
                      })()}
                    </tr>
                    <tr>
                      <td><b>Password</b></td>
                      {(() => {
                        if (showPasswordForm) {
                          return <td>
                            <Form.Control type="password"
                              onChange={(e) => setOldPassword(e.target.value)}
                              placeholder="current password"
                              value={oldPassword} />
                            <Form.Control type="password"
                              onChange={(e) => setNewPassword(e.target.value)}
                              placeholder="new password"
                              value={newPassword} />
                            <Form.Control type="password"
                              onChange={(e) => setNewPasswordConfirmation(e.target.value)}
                              placeholder="confirm new password"
                              value={newPasswordConfirmation} />
                            <ButtonGroup>
                              <Button variant="success py-0" onClick={() => handleChangePassword()}>✓</Button>
                              <Button variant="secondary py-0" onClick={() => setShowPasswordForm(false)}>X</Button>
                            </ButtonGroup>
                          </td>
                        }
                        else {
                          return <td>
                            ********&nbsp;
                            <Button variant="primary py-0" onClick={() => setShowPasswordForm(true)}>Edit</Button>
                          </td>
                        }
                      })()}
                    </tr>
                    <tr>
                      <td><b>Official Roles</b></td>
                      {(userInformation.roles.length > 0) ? (
                        <td> {userInformation.roles.map(role => (<><span> - {role}</span><br /></>))}</td>
                      ) : <td></td>}
                    </tr>
                    <tr>
                      <td><b>Default Language</b></td>
                      <td>
                        <DropdownButton variant="outline-secondary py-0" onSelect={(newLanguage, e) => handleLanguage(newLanguage)}
                          title={
                            <>
                              <img className="mb-1" alt={userInformation.language}
                                src={config.DIR_FLAGS + countries.find(c => c.language === userInformation.language).c4fCode + ".gif"}
                                height="12" width="20" />
                              &nbsp;{userInformation.language}
                            </>}
                        >
                          {
                            countries
                              .filter(c => 'language' in c)
                              .sort(function (a, b) { return a.language.localeCompare(b.language) })
                              .map(c =>
                                <Dropdown.Item key={c.language} eventKey={c.language}>
                                  <img className="mb-1" alt={c.language} src={config.DIR_FLAGS + c.c4fCode + ".gif"} height="12" width="20" />
                                  &nbsp;{c.language}
                                </Dropdown.Item>
                              )
                          }
                        </DropdownButton>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <b>Invisible in Chat</b>
                        <p>(not supported yet)</p>
                      </td>
                      <td>
                        <ButtonGroup>
                          <Button disabled variant={(userInformation.anonymousChat) ? 'primary py-0' : 'outline-primary py-0'} onClick={() => handleAnonymousChat(true)}>yes</Button>
                          <Button disabled variant={(!userInformation.anonymousChat) ? 'primary py-0' : 'outline-primary py-0'} onClick={() => handleAnonymousChat(false)}>no</Button>
                        </ButtonGroup>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <b>First Steps / Tutorial</b>
                        <p>(not supported yet)</p>
                      </td>
                      <td>
                        <ButtonGroup>
                          <Button disabled variant={(userInformation.firstSteps) ? 'primary py-0' : 'outline-primary py-0'} onClick={() => handleFirstSteps(true)}>yes</Button>
                          <Button disabled variant={(!userInformation.firstSteps) ? 'primary py-0' : 'outline-primary py-0'} onClick={() => handleFirstSteps(false)}>no</Button>
                        </ButtonGroup>
                      </td>
                    </tr>
                    <tr>
                      <td><b>Show Banner</b></td>
                      <td>
                        <ButtonGroup>
                          <Button variant={showBanner ? 'primary py-0' : 'outline-primary py-0'} onClick={() => setShowBanner(true)}>yes</Button>
                          <Button variant={!showBanner ? 'primary py-0' : 'outline-primary py-0'} onClick={() => setShowBanner(false)}>no</Button>
                        </ButtonGroup>
                      </td>
                    </tr>
                    <tr>
                      <td><b>Team Motto</b></td>
                      {(() => {
                        if (showMottoForm) {
                          return <td>
                            <Form.Control type="text"
                              onChange={(e) => setMotto(e.target.value)}
                              placeholder="motto"
                              value={motto} />
                            <ButtonGroup>
                              <Button variant="success py-0" onClick={() => handleMotto()}>✓</Button>
                              <Button variant="secondary py-0" onClick={() => setShowMottoForm(false)}>X</Button>
                            </ButtonGroup>
                          </td>
                        }
                        else {
                          return <td>
                            {motto}&nbsp;
                            <Button variant="primary py-0" onClick={() => setShowMottoForm(true)}>Edit</Button>
                          </td>
                        }
                      })()}
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />
              <h3>Team Jersey and Logo</h3>
              <div className="row d-flex justify-content-center">
                <div className="col" style={{ textAlign: "center" }}>
                  <p><b>Team Jersey</b></p>
                  <p align="center">
                    <Stage width={120} height={117}>
                      <Layer>
                        <RiderImage
                          url={config.DIR_JERSEYS + config.SUBDIR_USERJERSEYS + 'trikot_' + team.id + '.png?' + date.getTime()}
                          x={0} y={0}
                          width={120} height={117}
                        />
                      </Layer>
                    </Stage>
                  </p>
                  <div className="mb-5">
                    {(showJerseyEdit) ?
                      <Button variant="secondary py-0" onClick={() => setShowJerseyEdit(false)}>Close Dialogue</Button>
                      :
                      <Button variant="primary py-0" onClick={() => setShowJerseyEdit(true)}>Edit Jersey</Button>
                    }
                  </div>
                </div>
                <div className="col" style={{ textAlign: "center" }}>
                  <p><b>Team Logo</b></p>
                  <div>
                    <img alt="logo" src={"http://cycling4freaks.com/radsport/Upload/" + userInformation.userID + ".jpg"} style={{ maxHeight: "120px" }}></img>
                  </div>
                  <div>
                    <Button variant="primary py-0" disabled>Upload Logo</Button>
                  </div>
                </div>
                <div className="col" style={{ textAlign: "center" }}>
                  <p><b>Team Icon</b></p>
                  <div>
                    <img alt="icon" src="" style={{ maxHeight: "120px" }}></img>
                  </div>
                  <div>
                    <Button variant="primary py-0" disabled>Upload Icon</Button>
                  </div>
                </div>
              </div>
              {(showJerseyEdit) ?
                <div className="row d-flex  justify-content-center">
                  <div className="col" style={{ textAlign: "center", maxWidth: 700, backgroundColor: 'rgba(245, 250, 255, 1)' }}>
                    <h4>Create a new Jersey</h4>
                    <table className="table table-sm align-middle text-left">
                      <thead>
                        <tr>
                          <th>Preview</th>
                          <th>Components</th>
                          <th>Custom Design</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ verticalAlign: "middle", paddingRight: 10 }}>
                            <Stage width={120} height={117}>
                              <Layer>
                                {
                                  (selectedFileURL === null) ?
                                    <RiderImage
                                      url={TrikotBaseSimple}
                                      x={0} y={0}
                                      width={120} height={117}
                                    />
                                    :
                                    <RiderImage
                                      url={SampleJersey}
                                      x={0} y={0}
                                      width={120} height={117}
                                    />
                                }
                                <RiderImage
                                  url={bib}
                                  x={0} y={0}
                                  width={120} height={117}
                                />
                                <RiderImage
                                  url={jersey}
                                  x={0} y={0}
                                  width={120} height={117}
                                />
                                <RiderImage
                                  url={bike}
                                  x={0} y={0}
                                  width={120} height={117}
                                />
                                <RiderImage
                                  url={selectedFileURL}
                                  x={0} y={0}
                                  width={120} height={117}
                                />
                                <RiderImage
                                  url={TrikotBaseSimpleBg}
                                  x={0} y={0}
                                  width={120} height={117}
                                />
                              </Layer>
                            </Stage>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div><b>Jersey</b>
                              {(selectedFileURL === null) ?
                                <DropdownButton variant="outline-secondary py-0 my-1" title={jerseyColor}
                                  onSelect={(newJerseyColor, e) => handleJerseyColor(newJerseyColor)}>
                                  {['select', 'apricot', 'burgundy', 'charcoal', 'chocolate', 'ebony', 'ivory', 'lavender', 'mint', 'navy', 'sky'].map((jerseyColor) => (
                                    <Dropdown.Item eventKey={jerseyColor}>{jerseyColor}</Dropdown.Item>
                                  )
                                  )}
                                </DropdownButton>
                                :
                                <DropdownButton variant="outline-secondary py-0 my-1" title={jerseyColor}
                                  onSelect={(newJerseyColor, e) => handleJerseyColor(newJerseyColor)} disabled>
                                  {['select'].map((jerseyColor) => (
                                    <Dropdown.Item eventKey={jerseyColor}>{jerseyColor}</Dropdown.Item>
                                  )
                                  )}
                                </DropdownButton>
                              }
                            </div>
                            <b>Bib Short</b>
                            {(selectedFileURL === null) ?
                              <DropdownButton variant="outline-secondary py-0 my-1" title={bibColor}
                                onSelect={(newBibColor, e) => handleBibColor(newBibColor)}>
                                {['select', 'apricot', 'burgundy', 'charcoal', 'chocolate', 'ebony', 'ivory', 'lavender', 'mint', 'navy', 'sky'].map((bibColor) => (
                                  <Dropdown.Item eventKey={bibColor}>{bibColor}</Dropdown.Item>
                                )
                                )}
                              </DropdownButton>
                              :
                              <DropdownButton variant="outline-secondary py-0 my-1" title={bibColor}
                                onSelect={(newBibColor, e) => handleBibColor(newBibColor)} disabled>
                                {['select'].map((bibColor) => (
                                  <Dropdown.Item eventKey={bibColor}>{bibColor}</Dropdown.Item>
                                )
                                )}
                              </DropdownButton>
                            }
                            <b>Bike Frame</b>
                            {(selectedFileURL === null) ?
                              <DropdownButton variant="outline-secondary py-0 my-1" title={bikeColor}
                                onSelect={(newBikeColor, e) => handleBikeColor(newBikeColor)}>
                                {['select', 'apricot', 'burgundy', 'charcoal', 'chocolate', 'ebony', 'ivory', 'lavender', 'mint', 'navy', 'sky'].map((bikeColor) => (
                                  <Dropdown.Item eventKey={bikeColor}>{bikeColor}</Dropdown.Item>
                                )
                                )}
                              </DropdownButton>
                              :
                              <DropdownButton variant="outline-secondary py-0 my-1" title={bikeColor}
                                onSelect={(newBikeColor, e) => handleBikeColor(newBikeColor)} disabled>
                                {['select'].map((bikeColor) => (
                                  <Dropdown.Item eventKey={bikeColor}>{bikeColor}</Dropdown.Item>
                                )
                                )}
                              </DropdownButton>
                            }
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <p>
                              You can also create a custom design. Download the sample jersey, edit the jersey and upload here (only png-files, max. 1MB).
                            </p>
                            <a href={SampleJersey} download target='_blank'>
                              <Button variant="primary py-0">Download Sample Jersey</Button>
                            </a>
                            <br />
                            <br />
                            <Form>
                              <Form.Group controlId="formFile" className="mb-3">
                                <Form.Control type="file" accept=".png" onChange={handleFileSelect} />
                              </Form.Group>
                            </Form>
                            {(imageAlert !== "File OK.") ?
                              <Alert key="alert3" variant={'danger py-0 my-2'}>{imageAlert}</Alert>
                              :
                              <Alert key="alert3" variant={'success'}>{imageAlert}</Alert>
                            }
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={3} style={{ textAlign: "center", paddingBottom: 20, paddingTop: 15 }}>
                            {(() => {
                              if (selectedFileURL !== null) {
                                return <Button variant="success py-0" onClick={() => handleCustomJersey()}>Save Jersey</Button>
                              }
                              else if (bibColor !== 'select' && jerseyColor !== 'select' && bikeColor !== 'select') {
                                return <Button variant="success py-0" onClick={() => handleJerseyChange()}>Save Jersey</Button>
                              }
                              else {
                                return <Button variant="success py-0" disabled>Save</Button>
                              }
                            })()}
                            <Button variant="secondary py-0" onClick={() => setShowJerseyEdit(false)}>Don't save</Button>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={3}>
                            <br />
                            {(jerseyChangeInfo !== "Jersey saved.") ?
                              <Alert key="alert4" variant={'danger'}>{jerseyChangeInfo}</Alert>
                              :
                              <Alert key="alert4" variant={'success'}>{jerseyChangeInfo}</Alert>
                            }
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                :
                <div></div>
              }
            </div>
          </div>
        if (tab === 'reset')
          return <div className="row d-flex justify-content-center">
            <div className="col" style={{ minWidth: 400, maxWidth: "80vw" }}>
              <h3 className="mt-1">Team Reset</h3>
              Under specific circumstances, a team reset is possible for players that are unhappy with their team.<br />
              <br />
              <h5>Before the Reset</h5>
              You can reset your team, if it fulfills the following criteria: <br />
              - Currently in Division 6<br />
              - No recent reset (within last 15 days) <br />
              - Not signed up for any race (You can un-inscribe in the Inscription-Page.)<br />
              - No race today (If you had a race today, you can reset tomorrow.)<br />
              <br />
              <h5>After the Reset </h5>
              You will have <br />
              - 0 riders in your team <br />
              - 20,000,000 start budget <br />
              - the possibility to generate an automatic team (but can also buy riders on the market)<br />
              - same Profile Settings (Team Name, etc.) and your Palmarés<br />
              But, you will have to wait at least 15 days until you can reset your team, again. <br />
              {/* {(team.resetLock > 0) ? '(currently you have to wait at least ' + team.resetLock + ' days before your next reset)' : null} <br /> */}
              <br />
              <div style={{ textAlign: "center" }}><Button variant="danger mt-2 mb-2" onClick={() => setShowResetModal(true)}>Reset my Team</Button></div>
              <br />
              <Alert key="alert5" variant={'warning'}>{resetInfo}</Alert>
              <Modal key={'resetModal' + showResetModal}
                show={showResetModal}
                onHide={() => setShowResetModal(false)} >
                <Modal.Header closeButton>
                  <Modal.Title>Team Reset</Modal.Title>
                </Modal.Header>
                <Modal.Body>Do you really want to reset your team {userInformation.userName}?</Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowResetModal(false)}>{'Cancel'}</Button>
                  <Button variant="primary" onClick={handleReset}>{'Yes, reset.'}</Button>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        if (tab === 'generate')
          return <div className="row d-flex justify-content-center">
            <div className="col text-left" style={{ minWidth: 400, maxWidth: "80vw" }}>
              <h3 className="mt-1">Automatic Teams</h3>
              Automatic teams are a quick way to start the game.<br />
              <br />
              <h5>Before generating an automatic team</h5>
              You can generate an automatic team, if <br />
              - You have 0 riders in your team.<br />
              - You have sufficient budget.<br />
              This can be the case after a team-reset, but it's also possible for comeback-teams with enough budget.<br /><br />
              <b>Tip:</b> With an automatic team, you will have a useful team from the first race. Once players are more experienced, they usually select riders on the transfer market, especially young talented riders.  <br />
              <br />
              <h5>After generating an automatic team</h5>
              You will have <br />
              - 9 riders in your team <br />
              - Ca. 2,500,000 - 5,000,000 budget left for transfers (after reset) <br /><br />
              <b>Tip:</b> You can use the remaining cash to buy 1-2 young riders who will develop through training and might become stronger than automatically created riders.<br /><br />
              <div style={{ textAlign: "center" }}>
                <b>1) Select Team Type</b><br /> <ButtonGroup size="sm" >
                  {['Sprint', 'Climbing', 'Classics', 'Allround'].map(type =>
                    (<Button variant={(generatedTeamType === type) ? 'primary' : 'outline-primary'} onClick={() => setGeneratedTeamType(type)}>{type}</Button>))}
                </ButtonGroup> <br />
                <p>See below tables for details on each team type and rider type.</p>
                <b>2) Generate Riders </b><br /><Button variant="success" onClick={handleGenerateRiders}>Generate.</Button><br /><br />
                <Alert key="alert6" variant={'warning'}>{resetInfo}</Alert><br />
              </div>
              <h5><u>Available Automatic Teams</u></h5>
              <div className="m-0 p-0" style={{ maxHeight: 400, minWidth: 400, maxWidth: "80vw", overflow: "auto", backgroundColor: 'rgba(245, 250, 255, 1)' }}>
                <table className="table table-sm table-striped">
                  <thead>
                    <tr>
                      <th className="th-infotable" scope="col" style={{ textAlign: "left" }}>Rider Type</th>
                      <th className="th-infotable" scope="col">Climber Team</th>
                      <th className="th-infotable" scope="col">Classics Team</th>
                      <th className="th-infotable" scope="col">Sprinter Team</th>
                      <th className="th-infotable" scope="col">Allround Team</th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>Climber</td>
                      <td className="td-infotable">1</td>
                      <td className="td-infotable"></td>
                      <td className="td-infotable"></td>
                      <td className="td-infotable">1</td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>Classic</td>
                      <td className="td-infotable">1</td>
                      <td className="td-infotable">2</td>
                      <td className="td-infotable">1</td>
                      <td className="td-infotable">1</td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>Classic Pavé</td>
                      <td className="td-infotable"></td>
                      <td className="td-infotable">1</td>
                      <td className="td-infotable"></td>
                      <td className="td-infotable"></td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>60-80 Rider</td>
                      <td className="td-infotable">2</td>
                      <td className="td-infotable">1</td>
                      <td className="td-infotable">1</td>
                      <td className="td-infotable">1</td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>Sprinter</td>
                      <td className="td-infotable"></td>
                      <td className="td-infotable"></td>
                      <td className="td-infotable">1</td>
                      <td className="td-infotable">1</td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>Launcher</td>
                      <td className="td-infotable"></td>
                      <td className="td-infotable"></td>
                      <td className="td-infotable">1</td>
                      <td className="td-infotable"></td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>Flat</td>
                      <td className="td-infotable">1</td>
                      <td className="td-infotable">2</td>
                      <td className="td-infotable">3</td>
                      <td className="td-infotable">1</td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>Flat Pavé</td>
                      <td className="td-infotable"></td>
                      <td className="td-infotable">1</td>
                      <td className="td-infotable"></td>
                      <td className="td-infotable"></td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>Helper</td>
                      <td className="td-infotable">4</td>
                      <td className="td-infotable">2</td>
                      <td className="td-infotable">2</td>
                      <td className="td-infotable">4</td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>_</td>
                      <td className="td-infotable"></td>
                      <td className="td-infotable"></td>
                      <td className="td-infotable"></td>
                      <td className="td-infotable"></td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}><b>Total Riders</b></td>
                      <td className="td-infotable"><b>9</b></td>
                      <td className="td-infotable"><b>9</b></td>
                      <td className="td-infotable"><b>9</b></td>
                      <td className="td-infotable"><b>9</b></td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}><b>Total Price</b></td>
                      <td className="td-infotable"><b>15-17.5M</b></td>
                      <td className="td-infotable"><b>15-17.5M</b></td>
                      <td className="td-infotable"><b>15-17.5M</b></td>
                      <td className="td-infotable"><b>15-17.5M</b></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />
              <h5><u>Potential Rider Skills for Automatic Teams</u></h5>
              <div className="m-0 p-0" style={{ maxHeight: 400, minWidth: 400, maxWidth: "80vw", overflow: "auto", backgroundColor: 'rgba(245, 250, 255, 1)' }}>
                <table className="table table-sm table-striped">
                  <thead>
                    <tr>
                      <th className="th-infotable" scope="col" style={{ textAlign: "left" }}>Rider Type</th>
                      <th className="th-infotable" scope="col"><img src={SkillClimbing} title="Climbing" alt="Climbing" /></th>
                      <th className="th-infotable" scope="col"><img src={SkillFlat} title="Flat" alt="Flat" /></th>
                      <th className="th-infotable" scope="col"><img src={SkillDownhill} title="Downhill" alt="Downhill" /></th>
                      <th className="th-infotable" scope="col"><img src={SkillTimeTrial} title="TimeTrial" alt="TimeTrial" /></th>
                      <th className="th-infotable" scope="col"><img src={SkillSprint} title="Sprint" alt="Sprint" /></th>
                      <th className="th-infotable" scope="col"><img src={SkillCobbles} title="Cobbles" alt="Cobbles" /></th>
                      <th className="th-infotable" scope="col"><img src={SkillRegeneration} title="Regeneration" alt="Regeneration" /></th>
                      <th className="th-infotable" scope="col">Age</th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>Climber</td>
                      <td className="td-infotable">82-84</td>
                      <td className="td-infotable">55-57</td>
                      <td className="td-infotable">60-70</td>
                      <td className="td-infotable">46-55</td>
                      <td className="td-infotable">50-55</td>
                      <td className="td-infotable">53.5-57.9</td>
                      <td className="td-infotable">40-50</td>
                      <td className="td-infotable">25-29</td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>Classic</td>
                      <td className="td-infotable">68-70</td>
                      <td className="td-infotable">77-79</td>
                      <td className="td-infotable">60-70</td>
                      <td className="td-infotable">46-55</td>
                      <td className="td-infotable">50-56</td>
                      <td className="td-infotable">68.9-73.3</td>
                      <td className="td-infotable">40-55</td>
                      <td className="td-infotable">25-29</td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>Classic Pavé</td>
                      <td className="td-infotable">68-70</td>
                      <td className="td-infotable">77-79</td>
                      <td className="td-infotable">60-70</td>
                      <td className="td-infotable">46-55</td>
                      <td className="td-infotable">50-56</td>
                      <td className="td-infotable">73.4-77.8</td>
                      <td className="td-infotable">40-50</td>
                      <td className="td-infotable">25-29</td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>60-80 Rider</td>
                      <td className="td-infotable">58-60</td>
                      <td className="td-infotable">80-82</td>
                      <td className="td-infotable">60-70</td>
                      <td className="td-infotable">46-55</td>
                      <td className="td-infotable">50-56</td>
                      <td className="td-infotable">71.0-75.4</td>
                      <td className="td-infotable">45-55</td>
                      <td className="td-infotable">25-29</td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>Sprinter</td>
                      <td className="td-infotable">49-51</td>
                      <td className="td-infotable">56-58</td>
                      <td className="td-infotable">55-65</td>
                      <td className="td-infotable">46-55</td>
                      <td className="td-infotable">82-88</td>
                      <td className="td-infotable">54.2-58.6</td>
                      <td className="td-infotable">38-48</td>
                      <td className="td-infotable">25-29</td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>Launcher</td>
                      <td className="td-infotable">49-51</td>
                      <td className="td-infotable">80-82</td>
                      <td className="td-infotable">60-70</td>
                      <td className="td-infotable">46-55</td>
                      <td className="td-infotable">60-66</td>
                      <td className="td-infotable">71.0-75.4</td>
                      <td className="td-infotable">40-55</td>
                      <td className="td-infotable">25-29</td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>Flat</td>
                      <td className="td-infotable">50-52</td>
                      <td className="td-infotable">82-84</td>
                      <td className="td-infotable">60-70</td>
                      <td className="td-infotable">46-55</td>
                      <td className="td-infotable">50-56</td>
                      <td className="td-infotable">72.4-76.8</td>
                      <td className="td-infotable">40-55</td>
                      <td className="td-infotable">25-29</td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>Flat Pavé</td>
                      <td className="td-infotable">50-52</td>
                      <td className="td-infotable">82-84</td>
                      <td className="td-infotable">60-70</td>
                      <td className="td-infotable">46-55</td>
                      <td className="td-infotable">50-56</td>
                      <td className="td-infotable">76.9-81.3</td>
                      <td className="td-infotable">40-55</td>
                      <td className="td-infotable">25-29</td>
                    </tr>
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>Helper</td>
                      <td className="td-infotable">48-50</td>
                      <td className="td-infotable">75-77</td>
                      <td className="td-infotable">55-65</td>
                      <td className="td-infotable">44-53</td>
                      <td className="td-infotable">47-53</td>
                      <td className="td-infotable">67.5-71.9</td>
                      <td className="td-infotable">40-55</td>
                      <td className="td-infotable">25-29</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        if (tab === 'license')
          return <div>
            <div className="row d-flex justify-content-center">
              <div className="col text-left" style={{ minWidth: 400, maxWidth: "80vw" }}>
                <h3>License</h3>
                <p>
                  Currently, no license can be bought, so all features of the game are free for every player.<br />
                  In the future, a license with additional features may be offered to players.<br /><br />
                  Below you can see your license days and race points from the old version of the game:<br />
                </p>
                <h4 className="mt-4">
                  License Days: <span style={{ color: "green" }}>{userInformation.licensePoints}</span>
                </h4>
                <h4 className="mt-4">
                  Race Points: <span style={{ color: "green" }}>{userInformation.racePoints}</span>
                </h4>
                <br />
              </div>
            </div>
          </div>;
      })()}
      {tab === 'sitter' ?
        <>
          <div className="row d-flex justify-content-center">
            <div className="col text-left" style={{ minWidth: 400, maxWidth: "80vw" }}>
              <h5>Sitting Functionality in C4F</h5>
              <p> On this page, you can assign a 'Sitter' to your team, who can can sit you during stage races in case you would otherwise miss a stage.</p>
              <h5>Sitting Rules</h5>
              <ul>
                <li>Sitting is only permitted in stage races (prohibited for one-day races).</li>
                <li>During stage races, it is mandatory to be online at least 20% of the stages (no sitter logged in during those stages).</li>
                <li>It is prohibited to share your password with another team. Any case of password sharing will be treated like a multi account case.</li>
              </ul>
              <h5>Sitting Netiquette</h5>
              <ul>
                <li>If you are away in a stage race, let other teams know in the race chat who is sitting you and when.</li>
                <li>If you are the sitter, let other teams know in the race chat it's you and not the normal team manager.</li>
                <li>If you are racing against a sitter, be aware that the sitter may or may not have precise tactics from the normal manager.</li>
              </ul>
            </div>
          </div>
          <div className="row d-flex mt-1 p-1 justify-content-center align-items-flex-start">
            <div className="col ml-2 mr-1 my-1 p-0">
              <h5><u>Your Sitters</u></h5>
              <div className="m-0 p-0" style={{ maxWidth: 600, minWidth: 400, maxHeight: 500, overflow: "auto", backgroundColor: 'rgba(245,250,255,1)', textAlign: "center" }}>
                <Table size="sm" striped>
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Remove</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userInformation.sitters.map(sitter =>
                      <tr>
                        <td>{sitter.userName}</td>
                        <td><Button variant={'danger'} onClick={() => removeSitter(sitter.userName)}>X</Button></td>
                      </tr>)}
                  </tbody>
                </Table>
              </div>
              <br />
              <InputGroup>
                <Form.Control type={'text'}
                  onChange={(e) => setAdditionalSitter(e.target.value)}
                  placeholder={'additional sitter'}
                  value={additionalSitter} />
                <Button className="ml-1" variant={'primary'} onClick={() => addSitter(additionalSitter)}>Add</Button>
              </InputGroup>
            </div>
            <div className="col m-1 p-0">
              <h5><u>Teams you are sitting</u></h5>
              <div className="m-0 p-0" style={{ maxWidth: 600, minWidth: 400, maxHeight: 500, overflow: "auto", backgroundColor: 'rgba(245,250,255,1)', textAlign: "center" }}>
                <Table size="sm" striped>
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Enter</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userInformation.sittedTeams.map(team =>
                      <tr>
                        <td>{team.userName}</td>
                        <td><Button variant={'primary'} onClick={() => enterSittingAccount(team.userName)}>Enter</Button></td>
                      </tr>)}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>

        </>
        : null}
      <br />
      <p style={{ textAlign: "center" }}><br />If something goes wrong, please report errors in the <a href={config.FORUM_BASE_URL + 'viewforum.php?f=5'} target="_blank" rel="noreferrer">Bug-Area</a> in the <a href={config.FORUM_BASE_URL} target="_blank" rel="noreferrer">Forum</a>.</p>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>;
  else return null;
}

export default Profile;
